import { HALF_SECOND } from '../ygdrasil/libs/Consts'
import { Props } from '../components/BusinessPlanDrawer'

export const onPostUpdateOrganization = (props: Props, setFormProps) => {
  if (!props.form) return setFormProps(undefined)

  setTimeout(() => setFormProps(undefined), HALF_SECOND) // if not timeout then form is changed in the middle of animation => bad,
  props.onClose()
}
